export default function CardTitleCta({ item, classNames = "" }) {
    return (
        <div className={`card card-inversiones --theme-light ${classNames} --has-bg-img`}>
            <img className="img-el" src={item.cover} alt="Max Capital" />

            <div className="content-el">
                <h4 className="title title-4">{item.title}</h4>
            </div>
        </div>
    );
}
